import React from 'react'
import Isvg from 'react-inlinesvg'
import moment from 'moment'
import { Link } from 'react-router-dom'
import './Blog.scss'
import arrowRight from '../../sass/icons/arrow-right.svg'

const formatDateText = timestamp => {
    const date = moment(timestamp);
    return date.format('DD/MM/YYYY [às] HH:MM')
}

const BlogCard = ({image, title, caption, url, author_name, created_at, slug}) => {
    return (
        <Link to={`/artigos/${slug}`} className="blog-card grid">
            <figure className="col-6_xs-12">
                <img src={image} alt={title}/>
            </figure>
            <div className="col-6_xs-12 content">
                <h3>{title}</h3>
                <p>{caption}</p>
                <footer className="footer">
                    <p>
                        <span className="date">{formatDateText(created_at)}</span>
                        por
                        <span className="author">{author_name}</span>
                    </p>
                    <span>
                        <Isvg src={arrowRight} />
                    </span>
                </footer>
            </div>
        </Link>
    );
};

export default BlogCard;


// WEBPACK FOOTER //
// ./src/components/Card/Blog.js